const get = property => (state) => (state[property])
const set = property => (state, value) => (state[property] = value)
const toggle = property => (state) => (state[property] = !state[property])

export {
    get,
    set,
    toggle
}